import getSharingLink from '../selectors/getSharingLink';
import { findEmailAddress } from '../utils/findEmailAddress';
import { SharingLinkInfo } from 'owa-link-data';
import { GetPermissionInfoStatus } from 'owa-sharing-data';
import { mutator } from 'satcheljs';
import {
    addRecipientsIntoLink,
    updateRecipientPermissionInfos,
    removeRecipientsFromLink,
    setGetPermissionInfoFailure,
    resetSharingRecipientsInfo,
} from '../actions/publicActions';

mutator(addRecipientsIntoLink, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (!sharingLinkInfo) {
        return;
    }
    actionMessage.recipients.forEach(recipient => {
        if (
            !sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos.some(
                x => x.emailAddress === recipient.emailAddress
            )
        ) {
            sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos.push(recipient);
        }
    });
});

mutator(updateRecipientPermissionInfos, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (!sharingLinkInfo) {
        return;
    }
    actionMessage.results.forEach(result => {
        for (
            let i: number = 0;
            i < sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos.length;
            i++
        ) {
            const permissionInfo =
                sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos[i];
            if (permissionInfo.emailAddress === result.recipient.alias) {
                permissionInfo.hasAccess = result.hasAccess;
                permissionInfo.canHaveAccess = result.canBeInvited;
                permissionInfo.getPermissionInfoStatus = GetPermissionInfoStatus.Succeeded;
                break;
            }
        }
    });
});

mutator(setGetPermissionInfoFailure, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (!sharingLinkInfo) {
        return;
    }
    actionMessage.recipients.forEach(recipient => {
        for (
            let i: number = 0;
            i < sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos.length;
            i++
        ) {
            const permissionInfo =
                sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos[i];
            if (permissionInfo.emailAddress === recipient.emailAddress) {
                permissionInfo.getPermissionInfoStatus = GetPermissionInfoStatus.Failed;
                break;
            }
        }
    });
});

mutator(removeRecipientsFromLink, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (!sharingLinkInfo) {
        return;
    }
    sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos = sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos.filter(
        function(recipientPermissionInfo) {
            return !findEmailAddress(
                recipientPermissionInfo.emailAddress,
                actionMessage.recipients
            );
        }
    );
});

mutator(resetSharingRecipientsInfo, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (!sharingLinkInfo) {
        return;
    }

    sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos = [];
});
